import React, { useId } from 'react';
import type { Scenario } from '../../types/quote';
import { formatCurrency } from '../../utils/currency';
type CashToCloseProps = {
  scenario: Scenario;
};
export function CashToClose({
  scenario
}: CashToCloseProps) {
  const headingId = useId();
  return <section aria-labelledby={headingId} data-id="element-54" data-mp="3h15hvtv48npo">
      <h4 id={headingId} className="text-base font-extrabold" data-id="element-55" data-mp="3h047lrlxc590">
        Estimated cash to close
      </h4>

      <ul className="mt-2 divide-y divide-dashed divide-navy-100" data-id="element-56" data-mp="2jepzmpuv7m12">
        {scenario.cash.map(item => <li key={item.label} className="flex items-center justify-between gap-3 py-2.5" data-id="element-57" data-mp="2od19h0l5twja">
            <span className="flex min-w-0 items-center gap-2 text-sm font-bold" data-id="element-58" data-mp="2tat5a5oxe2sr">
              {item.label}
              {item.isCredit && <span className="shrink-0 rounded-full bg-flame-50 px-2 py-0.5 text-[11px] font-extrabold text-flame-700" data-id="element-59" data-mp="20mx6mvfsq0tc">
                  Credit
                </span>}
            </span>
            <span className={`shrink-0 text-sm font-extrabold tabular-nums ${item.isCredit ? 'text-flame-700' : ''}`} data-id="element-60" data-mp="2qk9s5zvi8zaa">
              {item.isCredit ? `− ${formatCurrency(item.amount, true)}` : formatCurrency(item.amount, true)}
            </span>
          </li>)}
      </ul>

      <div className="mt-3 flex flex-wrap items-center justify-between gap-x-4 gap-y-1 rounded-[22px] bg-flame-50 px-5 py-4 ring-1 ring-flame-100" data-id="element-61" data-mp="2ct4u327scf22">
        <span className="text-sm font-bold text-navy-700" data-id="element-62" data-mp="27vcx3tsaa2r0">Estimated cash to close</span>
        <span className="text-2xl font-black tabular-nums" data-id="element-63" data-mp="22txbo0m71u83">{formatCurrency(scenario.cashTotal, true)}</span>
      </div>
    </section>;
}